import { useState, useEffect } from "react";
import sanityClient from "../sanityClient";
import { tagQuery, tagPostsQuery } from "../queries/tagsQuery";
import { StandardLayout } from "../layouts/StandardLayout";
import { useParams } from "react-router-dom";
import { PostListLayout } from "../layouts/PostListLayout";

export default function SingleTag() {
    const [tagData, setTagData] = useState(null);
    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        if (!slug) return;

        setIsLoading(true);
        sanityClient
            .fetch(tagQuery, { slug })
            .then((data) => {
                if (data) {
                    setTagData(data);
                    return data;
                } else {
                    setError("Tag not found.");
                    throw new Error("Tag not found.");
                }
            })
            .then((tag) => {
                const tagId = tag._id;
                return sanityClient.fetch(tagPostsQuery, { tagId: tagId });
            })
            .then((data) => {
                if (data) {
                    setPostData(data);
                } else {
                    setError("Posts not found.");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError("Failed to fetch posts.");
                setIsLoading(false);
            });
    }, [slug]);

    if (isLoading) {
        return <StandardLayout title="Loading..." content="Loading..." />;
    }

    if (error) {
        return <StandardLayout title="Error" content={error} />;
    }

    if (!tagData) {
        return <StandardLayout title="Not Found" content="This category could not be found." />;
    }

    if (postData.length === 0) {
        return (
            <StandardLayout
                title={`posts tagged with: ${tagData.title}`}
                content={"No posts yet for this category."}
            />
        );
    } else {
        return <PostListLayout title={`posts tagged with: ${tagData.title}`} posts={postData} />;
    }
}
